<template>
  <div>
    <div class="panels">
      <table class="panel-rows brutoplate-rows mt-3">
        <thead>
          <tr>
            <th class="index">&nbsp;</th>
            <th class="length">Lengte</th>
            <th class="width">Breedte</th>
            <th class="amount">Aantal</th>
            <th class="reference text-left">Plaatreferentie</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="panel in material.panels" :key="panel.id" class="panel-row bg-light">
            <td class="index">
              {{ panel.id }}
            </td>
            <td class="length">
              {{ panel.length }}
            </td>
            <td class="width">
              {{ panel.width }}
            </td>
            <td class="amount">
              {{ panel.amount }}
              <div class="user"/>
            </td>
            <td class="reference text-left">
              {{ panel.reference }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { SAVE_ORDER_LOCAL_STORAGE, SELECT_MATERIAL } from '../../store/types'

  export default {
    data() {
      return {}
    },
    props: [
      'material'
    ]
  }
</script>

<style lang="scss" scoped>
</style>
